import { config } from "../../Config";

const RejectExtension = async (userId, extensionId, rejectionReason) => {
  if (!userId || !extensionId) {
    return { success: false, error: "Missing userId or extensionId" };
  }
  if (!rejectionReason || !rejectionReason.trim()) {
    return { success: false, error: "Rejection reason is required" };
  }
  try {
    const res = await fetch(config.rejectExtension, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ userId, extensionId, rejectionReason: rejectionReason.trim() }),
    });
    const data = await res.json().catch(() => ({}));
    if (!res.ok) {
      return { success: false, error: data.error || `HTTP ${res.status}` };
    }
    return { success: true, status: data.status, message: data.message };
  } catch (e) {
    return { success: false, error: e.message };
  }
};

export default RejectExtension;
